import { z } from 'zod';
import { isoDateTime } from './common.js';
import { sourceKindSchema } from './domain.js';
export const sourceStatusSchema = z.enum(['ok', 'error', 'disabled', 'pending']);
/** One configured source on the Health screen. Latency is over the last 24 hours. */
export const sourceHealthRowSchema = z.object({
    instanceId: z.string(),
    sourceId: z.string(),
    kind: sourceKindSchema,
    label: z.string(),
    status: sourceStatusSchema,
    lastSyncAt: isoDateTime.optional(),
    latencyMs: z.number().int().optional(),
    p95Ms: z.number().int().optional(),
    lastError: z.string().optional(),
});
export const sourceAlertSchema = z.object({
    instanceId: z.string(),
    label: z.string(),
    kind: sourceKindSchema,
    error: z.string(),
});
export const overviewSchema = z.object({
    sources: z.object({ total: z.number().int(), errors: z.number().int() }),
    users: z.object({ active: z.number().int(), disabled: z.number().int() }),
    /** Successful provider calls — live searches and sync runs — this 24 h and the 24 h before. */
    retrievals: z.object({ last24h: z.number().int(), prev24h: z.number().int() }),
    blocked24h: z.number().int(),
    lastReplyAt: isoDateTime.optional(),
    uptimeSeconds: z.number().int(),
    alerts: z.array(sourceAlertSchema),
});
//# sourceMappingURL=operations.js.map